import posthog, { type CaptureResult, type Properties } from 'posthog-js';

const EVENT = 'content.editor_request_failed';
const SAFE_PROPERTIES = new Set([
  'token',
  'distinct_id',
  '$device_id',
  '$session_id',
  '$window_id',
  '$pageview_id',
  '$lib',
  '$lib_version',
  '$is_identified',
  '$process_person_profile',
  'request_posthog_session_id',
  'request_posthog_window_id',
  'rails_request_id',
  'failure_kind',
  'http_status',
  'http_method',
  'resource_path',
  'company_id',
  'training_id'
]);

export const sanitizeEditorRequestFailure = (
  event: CaptureResult | null
): CaptureResult | null => {
  if (!event || event.event !== EVENT) return event;

  // SDK enrichment happens after capture(): URL/referrer and person properties
  // can contain the editor's access token. Sanitize the final envelope instead.
  return {
    uuid: event.uuid,
    event: event.event,
    timestamp: event.timestamp,
    properties: Object.fromEntries(
      Object.entries(event.properties).filter(([key]) =>
        SAFE_PROPERTIES.has(key)
      )
    )
  };
};

export const captureEditorRequestFailure = (properties: Properties): void => {
  const configured = posthog.config.before_send;
  const hooks = configured
    ? Array.isArray(configured)
      ? configured
      : [configured]
    : [];
  if (!hooks.includes(sanitizeEditorRequestFailure)) {
    posthog.set_config({
      before_send: [...hooks, sanitizeEditorRequestFailure]
    });
  }
  posthog.capture(EVENT, properties);
};
